import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonConfig } from 'src/app/models/button.component.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'confirm-dialog',
  templateUrl: './confirmation-dialog.component.html'
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ConfirmationDialog {
  public confirmMessage: string;
  buttonConfig = [
    new ButtonConfig('Ok', true, false, () => this.close(true)),
    new ButtonConfig('Cancel', false, true, () => this.close(false))
  ];

  constructor(public dialogRef: MatDialogRef<ConfirmationDialog>) {}

  close(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
